import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

interface PublicFeatureFlags {
  user_statistics_enabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);
  private readonly userStatisticsEnabled = signal(false);
  private initialization: Promise<void> | null = null;

  readonly canViewUserStatistics = computed(() => {
    const user = this.auth.currentUser();
    return this.userStatisticsEnabled()
      || user?.is_staff === true
      || user?.is_superuser === true;
  });

  initialize(): Promise<void> {
    if (!this.initialization) {
      this.initialization = this.load();
    }
    return this.initialization;
  }

  private async load(): Promise<void> {
    try {
      const flags = await firstValueFrom(
        this.http.get<PublicFeatureFlags>(`${environment.apiUrl}/api/config/features`),
      );
      this.userStatisticsEnabled.set(flags.user_statistics_enabled === true);
    } catch {
      // Fallo cerrado: no mostramos estadísticas si no podemos obtener la bandera.
      this.userStatisticsEnabled.set(false);
    }
  }
}
